import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnasayfaBilgi } from 'src/app/models/anasayfaBilgi.model';
import { Kullanici } from 'src/app/models/kullanici.model';
import { AnasayfaBilgiService } from 'src/app/services/anasayfa-bilgi.service';
import { GirisService } from 'src/app/services/giris.service';
import { KullaniciTalepService } from 'src/app/services/kullanici-talep.service';
import { YetkiService } from 'src/app/services/yetki.service';


@Component({
  selector: 'yonetim-anasayfa',
  templateUrl: './yonetim-anasayfa.component.html',
  styleUrls: ['./yonetim-anasayfa.component.css']
})
export class YonetimAnasayfaComponent implements OnInit {

  constructor(private anasayfaBilgiService: AnasayfaBilgiService, private girisService: GirisService, private kullaniciTalepService:KullaniciTalepService,private _yetkiService: YetkiService, private router: Router) {   this.yetkiService = _yetkiService;}
  anasayfaBilgi: AnasayfaBilgi = new AnasayfaBilgi();
  oran:number=0;
  talepSay:number=0;
  yetkiService: YetkiService;
  kullanici: Kullanici = new Kullanici();
  ngOnInit(): void {
    this.getAnasayfaBilgi();
  }

  getAnasayfaBilgi(){
    this.anasayfaBilgiService.getAnasayfaBilgi().subscribe(res => {
      this.anasayfaBilgi = res.data;
      this.oran=this.anasayfaBilgi.profilTamamlanmaOrani;
      this.kullanici=this.girisService.girisBilgi();
    });
  }

  talepSayisiKontrol() {
    this.kullaniciTalepService.nebisAktifTalepList().subscribe(res => {
      this.talepSay = res.data.length;
      if (this.talepSay > 2) {
        this._yetkiService.error("Hata ! Süreci devam eden en fazla 3 talep gönderebilirsiniz.", 1);
      }
      else {
        this.router.navigateByUrl('/talep-list/yeni')
      }
    });
  }
}
